__turbopack_context__.v({
  "productListItem": "styles-module__sBJXsG__productListItem",
  "seeMoreText": "styles-module__sBJXsG__seeMoreText",
});
